import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

export const Users = () => (
	<Switch>
		<Route path="/admin/users" exact component={List} />
		<Route path="/admin/users/create" component={Edit} />
		<Route path="/admin/users/:id" component={Edit} />
	</Switch>
);
